import React from "react";
import { Button } from "semantic-ui-react";
import DownloadButton from "@buttons/DownloadButton";
import ExpandButton from "@buttons/ExpandButton";
import useComplianceView from "@hooks/useComplianceView";
import useComplianceSummaryGrid from "@hooks/useComplianceSummaryGrid";

const ComplianceSummaryButtons = () => {
  const { expanded, isLoading, setViewData } = useComplianceView();
  const { onRefresh } = useComplianceSummaryGrid();

  return (
    <>
      <Button
        icon="refresh"
        positive
        onClick={onRefresh}
        content="Refresh"
        disabled={isLoading}
      />
      <ExpandButton
        size="medium"
        floated={false}
        compact={false}
        active={expanded}
        content={expanded ? "Display Graph" : "Hide Graph"}
        disabled={isLoading}
        onClick={() => setViewData({ expanded: !expanded })}
      />
      <DownloadButton
        caption="Export"
        disabled={isLoading}
        onClick={() => {}}
        size="medium"
      />
    </>
  );
};
export default ComplianceSummaryButtons;
